var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { AwesomeEvent, ComponentAPI } from '@philips-internal/oswald-ui-core';
import { ClickEventListener } from '@philips-internal/oswald-ui-core/lib/component/types';
export default class AppointmentDashboardCardAPI extends ComponentAPI {
    constructor() {
        super(...arguments);
        this.onClick = new ClickEventListener();
        this.onContextMenuClick = new ClickEventListener();
        this.onDoubleClick = new ClickEventListener();
    }
    setCancelSchedules(allowCancelCheckup) {
        this.setState({ allowCancelCheckup });
    }
    setConfirmSchedules(allowConfirmCheckup) {
        this.setState({ allowConfirmCheckup });
    }
    setOnEnterTeleconsultation(onEnterTeleconsultation) {
        this.setState({ onEnterTeleconsultation: onEnterTeleconsultation });
    }
    setOnAppointmentRescheduleMore(onAppointmentRescheduleMore) {
        this.setState({ onAppointmentRescheduleMore: onAppointmentRescheduleMore });
    }
    setOnAppointmentReschedule(onAppointmentReschedule) {
        this.setState({ onAppointmentReschedule: onAppointmentReschedule });
    }
    setOnAppointmentCancel(onAppointmentCancel) {
        this.setState({ onAppointmentCancel: onAppointmentCancel });
    }
    setOnAppointmentConfirm(onAppointmentConfirm) {
        this.setState({ onAppointmentConfirm: onAppointmentConfirm });
    }
    setTaskProgress(completedTasks, totalTasks) {
        this.setState({ completedTasks, totalTasks });
    }
    setPatientId(patientId) {
        this.setState({ patientId });
    }
    setRescheduleConsultation(rescheduleCheckup, rescheduleConsultation, rescheduleExam, rescheduleService) {
        this.setState({ rescheduleCheckup, rescheduleConsultation, rescheduleExam, rescheduleService });
    }
}
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AppointmentDashboardCardAPI.prototype, "onClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AppointmentDashboardCardAPI.prototype, "onContextMenuClick", void 0);
__decorate([
    AwesomeEvent,
    __metadata("design:type", Object)
], AppointmentDashboardCardAPI.prototype, "onDoubleClick", void 0);
//# sourceMappingURL=appointment-dashboard-card-api.js.map